import Charts from './charts/charts.js';
import CopyGuids from './copyGuids/copyGuids.js';
import HelpWithPage from './helpWithPage/helpWithPage.js';

export default angular.module('eventix.dashboard.components', [
    Charts,
    CopyGuids,
    HelpWithPage,
]).name;
